import * as download from 'downloadjs';

import { ResponseTypes, sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getPermanentLicenses() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_full_permanent_licenses'
      })
    }
  );
}

export function getPermanentLicenseById(permanentLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_permanent_license_by_id',
        id: permanentLicenseId,
      })
    }
  );
}

export function createNewPermanentLicenses(clientId, productName, type, features, supportDayCount, licenseCount = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'create_new_permanent_license',
        client_id: clientId,
        product_name: productName,
        type: type,
        features,
        license_count: licenseCount,
        support_day_count: supportDayCount
      })
    }
  );
}

export function updatePermanentLicense(permanentLicenseId, features, supportDayCount = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'update_permanent_license',
        perm_lic_id: permanentLicenseId,
        features,
        support_day_count: supportDayCount,
      })
    }
  );
}

export function removePermanentLicenses(permanentLicenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'remove_permanent_licenses',
        perm_lic_ids: permanentLicenseIds
      })
    }
  );
}

export function deactivatePermanentLicense(permanentLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'deactivate_permanent_license',
        perm_lic_id: permanentLicenseId
      })
    }
  );
}

export function getPermanentLicenseHistory(permanentLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_permanent_license_history',
        perm_lic_id: permanentLicenseId
      })
    }
  );
}

export function getOnlineLicLivingStates() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_online_license_living_states'
      })
    }
  ).then(livingStates => livingStates).catch(error => {
    throw error
  });
}

export function restorePermanentLicenses(permanentLicenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'restore_permanent_licenses',
        perm_lic_ids: permanentLicenseIds
      })
    }
  );
}

export function changePermanentLicense(productName, type, permanentLicenseId, features, supportDayCount = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'change_permanent_license',
        product_name: productName,
        type,
        perm_lic_id: permanentLicenseId,
        features,
        support_day_count: supportDayCount
      })
    }
  );
}

export function getPermanentLicenseByKey(licenseKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_permanent_license_by_key',
        license_key: licenseKey
      })
    }
  ).then(license => Object.keys(license).length === 0 ? null : license);
}

export function assignLicenseToClient(licenseId, clientId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'assign_permanent_license_to_client',
        license_id: licenseId,
        client_id: clientId
      })
    }
  );
}

export function reactivatePermanentLicense(licenseId, deviceKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'reactivate_permanent_license',
        license_id: licenseId,
        device_key: deviceKey
      })
    }
  );
}

export function activateLicense(licenseId, deviceKey = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'activate_permanent_license',
        license_id: licenseId,
        device_key: deviceKey
      })
    }
  );
}

export function downloadLicense(licenseId = null) {
  return sendRequestWithAuth(
    `${settings.ServerURL}?operation=get_permanent_license_file&license_id=${licenseId}`, {
      method: 'GET'
    }, ResponseTypes.file
  ).then(file => download(file.data, file.name));
}

export function getPermanentLicenseHistoryById(permanentLicenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_permanent_license_history_by_id',
        id: permanentLicenseId
      })
    }
  );
}

export function addPermanentLicenseToFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'permanent_license', 'add', licenseId
    )
  );
}

export function removePermanentLicenseFromFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'permanent_license', 'remove', licenseId
    )
  );
}



// WEBPACK FOOTER //
// ./src/services/permanentLicenses.js